/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_10_QInputs */

const en_tut_tr_10_q = /** @type {(inputs: Tut_Tr_10_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My meeting recording is gone.`)
};

const id_tut_tr_10_q = /** @type {(inputs: Tut_Tr_10_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekaman rapat saya hilang.`)
};

/**
* | output |
* | --- |
* | "My meeting recording is gone." |
*
* @param {Tut_Tr_10_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_10_q = /** @type {((inputs?: Tut_Tr_10_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_10_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_10_q(inputs)
	return en_tut_tr_10_q(inputs)
});